import { StyleProps, styled } from "@shared/primitive-components"

interface ExtendedStyleProps extends StyleProps {
  isOpen: boolean
}

const StyledBar = styled.div<ExtendedStyleProps>((props) => ({
  boxSizing: `border-box`,
  display: `flex`,
  flexDirection: `column`,
  justifyContent: `space-between`,
  width: `100%`,
  height: props.isOpen ? `100vh` : `80px`,
  position: `fixed`,
  top: 0,
  zIndex: 10000,
  "overflow-y": props.isOpen ? `auto` : `hidden`,
  scrollbarWidth: `thin`,
  scrollbarColor: `rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05)`,
  "&::-webkit-scrollbar": {
    width: `4px`,
    backgroundColor: props.theme.palette.grey.light,
    borderRadius: `4px`,
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: `rgba(0, 0, 0, 0.2)`,
    borderRadius: `4px`,
  },
  backgroundColor: props.theme.palette.coal.dark,
  [props.theme.breakPoints.md.up]: {
    width: `200px`,
    height: `100vh`,
    justifyContent: `flex-start`,
  },
}))

export default StyledBar
